import { useTheme } from "@mui/material/styles";
import { customShadows } from "src/theme/shadows";

export const useCommonStyles = () => {
  const theme = useTheme();

  return {
    formContainer: {
      px: { xs: 0, md: 6, lg: 12, xl: 24 },
      "& .MuiTypography-h6": {
        color: theme.palette.text.label,
        fontSize: "20px",
      },
      "& .MuiTypography-body2": {
        color: theme.palette.text.label,
      },
    },
    inputContainer: {
      p: 2,
      borderRadius: 1,
      boxShadow: customShadows.light.manualFormCards,
      border: `1px solid ${theme.palette.text.borderLine}`,
    },
    tableHeader: {
      backgroundColor: theme.palette.text.input,
      borderRadius: "12px",
      border: `1px solid ${theme.palette.text.borderLine}`,
      borderBottom: `1px solid ${theme.palette.text.borderLine}`,
    },
    tableContainer: {
      borderRadius: "12px",
      border: `1px solid ${theme.palette.text.borderLine}`,
      overflow: "hidden",
      "& .MuiTableCell-root": {
        color: theme.palette.text.label,
      },
    },
    table: {
      borderCollapse: "separate",
      borderSpacing: 0,
    },
    tableRow: {
      border: `1px solid ${theme.palette.text.borderLine}`,
    },
  };
};
